<template>
  <div id="vfg-render">
    <!-- {{ model }} -->
    <VueFormGenerator
      :model="model"
      :schema="schema"
    />

    <b-button @click="addOrUpdateEntry">
      Save
    </b-button>
    &nbsp;
    <b-button
      v-if="entry"
      @click="deleteEntry"
    >
      Delete
    </b-button>
  </div>
</template>

<script>
import Entry from '@/vuex/orm/models/Entry';
import moment from 'moment';

export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      entry: {},
      selectedDate: new Date(),
      errors: {},
      schema: {
        fields: [],
      },
      model: {},
    };
  },

  mounted() {
    Bus.$on('day_clicked', (day) => {
      this.addOrUpdateEntry();
      this.selectedDate = day.date;
      this.loadEntryForDate();
    });

    this.schema = JSON.parse(JSON.stringify(this.form.form.schema));

    this.loadEntryForDate();
  },

  beforeDestroy() {
    this.addOrUpdateEntry();
    Bus.$off('day_clicked');
  },

  methods: {
    loadEntryForDate() {
      this.entry = Entry.query()
        .where('date', moment(this.selectedDate).format('YYYY-MM-DD'))
        .first();

      if (this.entry) {
        this.model = this.entry.model;
      } else {
        this.model = JSON.parse(JSON.stringify(this.form.form.model));
      }
    },

    addOrUpdateEntry() {
      this.$store.state.loading = true;
      this.errors = {};

      const model = JSON.parse(JSON.stringify(this.model));

      if (Object.values(model).filter((el) => el !== '').length > 0) {
        const data = Object.assign(model, {
          form_id: this.form.id,
          date: this.selectedDate,
          token: this.$auth.token(),
        });

        Entry.$create({
          data,
        })
          .then((/* response */) => {
            // console.log('success', response);
            Bus.$emit('fetch_entries');
            Bus.$emit('reset_calendar');
          })
          .catch((response) => {
            // console.log('error', response.message, response.errors);
            this.errors = response.errors;
          });
      }

      this.$store.state.loading = false;
    },

    deleteEntry() {
      Entry.$delete({
        params: {
          id: this.entry.id,
        },
      })
        .then((/* response */) => {
          // console.log('success', response);
          Bus.$emit('fetch_entries');
          Bus.$emit('reset_calendar');
        })
        .catch((response) => {
          // console.log('error', response.message, response.errors);
          this.errors = response.errors;
        });
    },
  },
};
</script>

<style scoped>
#vfg-render {
  max-width: 40vw;
  margin: 0 auto;
}
</style>

<style>
.field-group {
  /* border: 2px solid #bbb; */
  padding: 8px;
  border-radius: 4px;
}

.subgroup {
  border-color: goldenrod;
}

.subgroup legend {
  color: #00268d;
}
</style>
